import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Chatbot from "./Components/Chatbot";
import ScrollToTop from "./Components/ScrollToTop";
import ScrollProgress from "./Components/ScrollProgress";
import SiteLoader from "./Components/SiteLoader";
import LandingPage from "./Components/Pages/LandingPage";
import About from "./Components/Pages/About";
import Services from "./Components/Pages/Services";
import Projects from "./Components/Pages/Projects";
import Contact from "./Components/Pages/Contact";
import { useBandwidth } from "./context/BandwidthContext";
import "./App.css";

function App() {
  const { lowData } = useBandwidth();

  return (
    <MotionConfig reducedMotion={lowData ? "always" : "user"}>
      <Router>
        <ScrollToTop />
        <ScrollProgress />
        <SiteLoader />
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/About" element={<About />} />
              <Route path="/Services" element={<Services />} />
              <Route path="/Projects" element={<Projects />} />
              <Route path="/Contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
          <Chatbot />
        </div>
      </Router>
    </MotionConfig>
  );
}

export default App;
